export function isDevelopmentModeEnabled(): boolean {
  const envVal = window.__ENV__?.ENABLE_DEVELOPMENT_MODE;
  if (envVal && envVal !== '__ENABLE_DEVELOPMENT_MODE_PLACEHOLDER__') {
    return envVal === 'true';
  }
  return import.meta.env.ENABLE_DEVELOPMENT_MODE === 'true';
}

export type CreatableProduct = 'currentAccount' | 'termDeposit';

const PRODUCT_CREATION_FLAGS = {
  currentAccount: 'ENABLE_CREATE_CURRENT_ACCOUNT',
  termDeposit: 'ENABLE_CREATE_TERM_DEPOSIT',
} as const satisfies Record<
  CreatableProduct,
  keyof NonNullable<Window['__ENV__']>
>;

/**
 * Založení produktu jde vypnout za běhu z konfigurace serveru (IIS web.config,
 * env proměnná kontejneru), bez nového releasu. Vypíná se jen výslovným
 * `false`: nepřepsaný placeholder — tedy server, který o flagu neví — nechá
 * založení zapnuté, stejně jako před zavedením flagu.
 */
export function isProductCreationEnabled(product: CreatableProduct): boolean {
  const value = window.__ENV__?.[PRODUCT_CREATION_FLAGS[product]];
  return value?.trim().toLowerCase() !== 'false';
}
